import { StationData } from "@/models/asset";

export function hasSecondStation(stateValue: StationData<any>): boolean {
  return !!stateValue?.stationTwo;
}
